<div style="background-color: var(--vz-body-bg);">

    <div class="modal-header bg-soft-info p-3">
        <h5 *ngIf="(!model.id)" class="modal-title" id="exampleModalLabel"> <span i18n="@@">Create</span></h5>
        <h5 *ngIf="(model.id)" class="modal-title" id="exampleModalLabel"> <span i18n="@@">Edit</span> -
            {{model.name}} {{model.lastName}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
            (click)="close()"></button>
    </div>
    <div style="padding: 1.5rem;" >
        <app-user-profile (keypress)="userEdited = true" style=" overflow: scroll; min-height: 48rem; max-height:fit-content; "
        (change)="userEdited = true" [model]="model" [tenantId]="tenantId" [display]="1"></app-user-profile>
    </div>
</div>
